/* assets/about-fitclan.js */

document.addEventListener('DOMContentLoaded', () => {
  const animatedSections = document.querySelectorAll('.about-fitclan--animated');

  if (!animatedSections.length) return;

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  animatedSections.forEach(section => {
    observer.observe(section);
  });
});
